

/**
 * Construct enum properties dict from array of property defs
 * @param {{
 *   Alias: string,
 *   Code: string,
 *   DescriptionString: string,
 *   DisplayOrder: number,
 *   DisplayString: string,
 *   EnumDef: {
 *     Alias: string,
 *     Code: string,
 *     DisplayString: string,
 *     Value: any
 *   }[] | null,
 *   Type: number,
 * }[] | null} propertyDefs
 * @returns {{
 *   [code: string]: {
 *     Alias: string,
 *     Code: string,
 *     DescriptionStrign: string,
 *     DisplayOrder: number,
 *     EnumDef: {
 *       [code: string]: {
 *         Alias: string,
 *         Code: string,
 *         DescriptionString: string,
 *         Value: any
 *       }
 *     }
 *   }
 * }}
 */
export function constructEnumPropertiesDict(propertyDefs) {
  const enumPropertyDefs = propertyDefs?.filter(propertyDef => propertyDef.EnumDef) ?? []
  return Object.fromEntries(enumPropertyDefs.map(propertyDef => [propertyDef.Code, {
    ...propertyDef,
    EnumDef: Object.fromEntries(propertyDef.EnumDef?.map(enumDef => [enumDef.Code, enumDef]) ?? []),
  }]))
}

export function getAliasOrDisplayString(obj) {
  return obj?.Alias || obj?.DisplayString || ""
}

export function getAliasOrDisplayStringForEnumValue(enumPropertyDef, enumValueCode) {
  if (enumPropertyDef?.EnumDef?.[enumValueCode]) return getAliasOrDisplayString(enumPropertyDef.EnumDef[enumValueCode])
  return enumValueCode
}
